export interface InvoiceSettlementAmounts {
  resolvedAmount: number;
  remainingAmount: number;
  overpaidAmount: number;
}

const parseMoney = (
  value: string | number | null | undefined,
): number | null => {
  if (value == null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const roundMoney = (value: number): number => Number(value.toFixed(2));

export const getInvoiceSettlementAmounts = (
  amount: string | number | null | undefined,
  amountOutstanding: string | number | null | undefined,
): InvoiceSettlementAmounts | null => {
  const total = parseMoney(amount);
  const outstanding = parseMoney(amountOutstanding);
  if (total == null || outstanding == null) return null;

  return {
    resolvedAmount: Math.max(0, roundMoney(total - outstanding)),
    remainingAmount: Math.max(0, roundMoney(outstanding)),
    overpaidAmount: Math.max(0, roundMoney(-outstanding)),
  };
};

export const formatInvoiceMoney = (value: number, language: string): string => {
  const locale =
    language.startsWith("no") || language.startsWith("nb") ? "nb-NO" : "en-GB";
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
  }).format(value);
};
